module.exports = __webpack_public_path__ + "static/media/Plateau_H_1.0f6641d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_H_1.svg
// module id = 783
// module chunks = 0